import { media, style } from "typestyle";
import { colors, queries } from "styles/styles";

export const InfoBubble = style(
  {
    padding: "4px 12px",
    borderRadius: "40px",
    border: `1px solid ${colors.hooplaBorderColor}`,
    fontSize: "15px",
    display: "flex",
    boxShadow: `0 2px 2px ${colors.hooplaShadowColor}`,
    $nest: {
      "&:not(:last-child)": {
        marginBottom: "5px"
      }
    }
  },
  media(queries.medium, {
    $nest: {
      "&:not(:last-child)": {
        marginRight: "15px",
        marginBottom: 0
      }
    }
  })
);
